import containerQueries from '@tailwindcss/container-queries';

import { Config } from 'tailwindcss/types/config';

const CineamoTheme = {
    // Registered on the preset (not each app's own tailwind.config.ts plugins array) so every app
    // gets it via `presets: [CineamoTheme]` — Tailwind merges a preset's `plugins` with the config's
    // own rather than one replacing the other, so this adds to what each app already lists.
    plugins: [containerQueries],
    theme: {
        extend: {
            aspectRatio: {
                poster: '2 / 3',
                backdrop: '16 / 9'
            },
            backgroundImage: {
                'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
                'gradient-light': 'linear-gradient(to bottom, #F2F2F2, #DAE0EDE5)'
            },
            width: {
                24: '24px',
                34: '34px',
                42: '42px',
                50: '50px',
                56: '56px',
                60: '60px',
                65: '65px',
                72: '72px',
                78: '78px',
                80: '80px',
                86: '86px',
                94: '94px',
                100: '100px',
                110: '110px',
                112: '112px',
                125: '125px',
                130: '130px',
                140: '140px',
                150: '150px',
                160: '160px',
                170: '170px',
                175: '175px',
                180: '180px',
                200: '200px',
                215: '215px',
                220: '220px',
                240: '240px',
                250: '250px',
                260: '260px',
                300: '300px',
                340: '340px',
                350: '350px',
                400: '400px',
                440: '440px',
                500: '500px',
                618: '618px',
                660: '660px',
                700: '700px',
                icon: '40px',
                'icon-lg': '60px',
                'list-backdrop': '107px',
                'mobile-modal': '90%',
                'two-column-image': '80%'
            },
            height: {
                icon: '40px',
                'icon-lg': '60px',
                24: '24px',
                26: '26px',
                30: '30px',
                36: '36px',
                42: '42px',
                48: '48px',
                50: '50px',
                56: '56px',
                60: '60px',
                72: '72px',
                80: '80px',
                114: '114px',
                120: '120px',
                130: '130px',
                140: '140px',
                144: '144px',
                160: '160px',
                168: '168px',
                175: '175px',
                180: '180px',
                192: '192px',
                200: '200px',
                210: '210px',
                216: '216px',
                220: '220px',
                225: '225px',
                230: '230px',
                240: '240px',
                250: '250px',
                260: '260px',
                264: '264px',
                288: '288px',
                300: '300px',
                312: '312px',
                330: '330px',
                336: '336px',
                360: '360px',
                370: '370px',
                384: '384px',
                400: '400px',
                408: '408px',
                432: '432px',
                456: '456px',
                480: '480px',
                500: '500px',
                640: '640px',
                700: '700px',
                800: '800px',
                864: '806.4px',
                900: '900px',
                'mobile-modal': '90%',
                navbar: '60px',
                'list-backdrop': '160px'
            },
            minWidth: {
                icon: '40px',
                'icon-lg': '60px',
                32: '32px',
                36: '36px',
                46: '46px',
                48: '48px',
                72: '72px',
                82: '82px',
                100: '100px',
                124: '124px',
                140: '140px',
                148: '148px',
                160: '160px',
                200: '200px',
                215: '215px',
                300: '300px',
                500: '500px',
                '1/3': '33.333333%',
                '2/5': '40%',
                '3/5': '60%',
                '2/3': '66.666666%'
            },
            maxWidth: {
                icon: '40px',
                'icon-lg': '60px',
                100: '100px',
                140: '140px',
                160: '160px',
                250: '250px',
                300: '300px',
                400: '400px',
                '2/5': '40%',
                '1/2': '50%',
                '3/5': '60%',
                '2/3': '66.666666%'
            },
            minHeight: {
                icon: '40px',
                'icon-lg': '60px',
                24: '24px',
                32: '32px',
                48: '48px',
                50: '50px',
                64: '64px',
                72: '72px',
                74: '74px',
                80: '80px',
                120: '120px',
                225: '225px',
                300: '300px',
                330: '330px',
                400: '400px',
                500: '500px',
                '1/2': '50%',
                '3/5': '60%',
                '2/3': '66.666666%'
            },
            maxHeight: {
                icon: '40px',
                'icon-lg': '60px',
                26: '26px',
                32: '32px',
                42: '42px',
                160: '160px',
                180: '180px',
                248: '248px',
                400: '400px',
                480: '480px',
                500: '500px',
                'mobile-modal': '90%'
            },
            spacing: {
                1: '1px',
                2: '2px',
                4: '4px',
                5: '5px',
                6: '6px',
                7: '7px',
                8: '8px',
                9: '9px',
                10: '10px',
                11: '11px',
                12: '12px',
                13: '13px',
                14: '14px',
                16: '16px',
                18: '18px',
                19: '19px',
                20: '20px',
                22: '22px',
                24: '24px',
                28: '28px',
                32: '32px',
                36: '36px',
                38: '38px',
                40: '40px',
                44: '44px',
                48: '48px',
                50: '50px',
                52: '52px',
                56: '56px',
                57: '57px',
                60: '60px',
                64: '64px',
                65: '65px',
                72: '72px',
                84: '84px',
                90: '90px',
                96: '96px',
                100: '100px',
                108: '108px',
                120: '120px',
                138: '138px',
                148: '148px',
                160: '160px',
                164: '164px',
                264: '264px',
                320: '320px',
                '1/10': '10%',
                '2/10': '20%'
            },
            lineHeight: {
                22: '22px',
                24: '24px',
                28: '28px',
                38: '38px',
                48: '48px'
            },
            borderWidth: {
                1: '1px'
            },
            borderSpacing: {
                10: '10px'
            },
            divideWidth: {
                0.5: '0.05rem'
            },
            opacity: {
                15: '0.15',
                65: '0.65'
            },
            transitionProperty: {
                width: 'width',
                height: 'height, max-height'
            },
            keyframes: {
                progressBar: {
                    '0%': { transform: 'scaleX(0)' },
                    '100%': { transform: 'scaleX(1)' }
                },
                pingWithPauseKeyframes: {
                    '0%, 70%': {
                        transform: 'scale(1)',
                        opacity: '1'
                    },
                    '90%, 100%': {
                        transform: 'scale(2)',
                        opacity: '0'
                    }
                },
                fadeOut: {
                    '0%': { opacity: '0.3' },
                    '100%': { opacity: '0' }
                },
                'pulse-skeleton': {
                    '0%, 100%': {
                        opacity: '1'
                    },
                    '50%': {
                        opacity: '0.5'
                    }
                },
                'infinite-scroll': {
                    from: { transform: 'translateX(0)' },
                    to: { transform: 'translateX(-50%)' }
                },
                'slide-in-up': {
                    from: { opacity: '0', transform: 'translateY(12px)' },
                    to: { opacity: '1', transform: 'translateY(0)' }
                },
                typewriter: {
                    from: { maxWidth: '0' },
                    to: { maxWidth: '100%' }
                }
            },
            animation: {
                progressBar2500: 'progressBar 2500ms',
                bounce200: 'bounce 1s infinite 200ms',
                bounce400: 'bounce 1s infinite 400ms',
                pingWithPause: 'pingWithPauseKeyframes 3s cubic-bezier(0, 0, 0.2, 1) infinite',
                'fade-glow': 'fadeOut 2s ease-out',
                'pulse-skeleton': 'pulse-skeleton 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                'infinite-scroll': 'infinite-scroll 30s linear infinite',
                'infinite-scroll-reverse': 'infinite-scroll 30s linear infinite reverse',
                'slide-in-up': 'slide-in-up 0.3s ease-out forwards',
                typewriter: 'typewriter 0.8s steps(var(--typewriter-steps, 30)) 0.5s forwards'
            },
            zIndex: {
                'navigation-dropdown': '-1',
                // Below `dropdown` (50) on purpose: a sticky table header must never cover the
                // filter popup that its own column opened.
                'table-header': '10',
                'menu-button': '150',
                navigation: '49',
                dropdown: '50',
                'modal-view': '9000',
                // For popovers, menus and tooltips that belong to something already at
                // `modal-view`. They are portalled to `document.body`, so the usual `z-dropdown`
                // (50) would put them behind the very surface that opened them — which reads to
                // the user as "the button does nothing".
                'modal-view-overlay': '9100',
                'loading-overlay': '9999'
            },
            boxShadow: {
                'filter-sheet': '0 -10px 20px 0 #0000000D',
                cyan: '0 0 10px 0 #00FFDC',
                'cyan-transparent': '0 0 4px 0 #00FFDC80',
                'darkBlue-20': '0 0 6px 0 #00002332'
            },
            gradientColorStopPositions: {
                20: '20%'
            },
            lineClamp: {
                2: '2',
                10: '10'
            }
        },

        letterSpacing: {
            small: '0.02em',
            regular: '0.035em',
            medium: '0.05em',
            wide: '1px'
        },

        fontFamily: {
            sans: ['Montserrat', 'Montserrat, Arial, sans-serif']
        },

        fontSize: {
            5: '5px',
            7: '7px',
            8: '8px',
            9: '9px',

            'headline-72': '72px',
            'headline-56': '56px',
            'headline-42': '42px',
            'headline-32': '32px',
            'headline-24': '24px',
            'headline-20': '20px',
            'headline-18': '18px',

            'body-20': '20px',
            'body-18': '18px',
            'body-16': '16px',
            'body-14': '14px',
            'body-12': '12px',
            'body-11': '11px',
            'body-10': '10px',
            'body-56': '56px',

            'body-bold-20': '20px',
            'body-bold-18': '18px',
            'body-bold-16': '16px',
            'body-bold-14': '14px',
            'body-bold-12': '12px',
            'body-bold-10': '10px',

            'overline-16': '16px',
            'overline-14': '14px',
            'overline-12': '12px',
            'overline-10': '10px',

            'button-16': '16px',
            'button-14': '14px',
            'button-12': '12px',
            'button-10': '10px',

            'input-labels-12': '12px'

            // '2xl': '32px',
        },

        borderRadius: {
            0: '0px',
            2: '2px',
            3: '3px',
            4: '4px',
            8: '8px',
            12: '12px',
            16: '16px',
            switch: '12px',
            full: '100%'
        },

        colors: {
            transparent: 'transparent',
            current: 'currentColor',
            cyan: {
                DEFAULT: '#00FFDC',
                light: '#3fffe4',
                middle: '#13E2C6',
                'on-white-bg': '#13E2C6',
                'high-contrast': '#07757C',
                dark: '#00AAA0',
                transparent: '#00FFDC80',
                'transparent-20': 'rgba(0,255,220,0.2)',
                link: '#79F9E7'
            },
            darkBlue: {
                DEFAULT: '#000023',
                light: {
                    DEFAULT: '#1A0A49',
                    50: '#1A0A4980'
                },
                lightest: '#000063',
                transparent: '#00002380',
                supertransparent: '#00002333',
                'transparent-30': '#0000234C',
                bannerBg: '#231A39'
            },
            blue: {
                DEFAULT: '#0071F7',
                light: '#6BAFFF',
                lightest: '#C5DEFC',
                transparent: '#0071F780',
                'transparent-20': '#0071F754',
                supertransparent: '#0071F733',
                'high-contrast': '#005fd1',
                pale: '#D1E6FE'
            },
            purple: {
                DEFAULT: '#9B51E0',
                light: '#DD82FF',
                lightest: '#EAC4F9',
                pale: '#EBDCF9',
                transparent: '#9B51E080',
                'transparent-20': '#9B51E054',
                'light-transparent-20': '#DD82FF54'
            },
            green: {
                DEFAULT: '#40E587',
                light: '#79E9A8',
                lightest: '#B6F8D1',
                'high-contrast': '#179D50',
                middle: '#22C266'
            },
            berry: {
                DEFAULT: '#FC0073',
                light: '#FF4387',
                lightest: '#FC94C3'
            },
            black: {
                light: '#222222',
                DEFAULT: '#000000'
            },
            white: {
                DEFAULT: '#F2F2F2',
                80: '#F2F2F2CB',
                50: '#F2F2F280',
                38: '#F2F2F260',
                20: '#F2F2F234',
                10: '#F2F2F219'
            },
            gray: {
                DEFAULT: '#CCCCD4',
                light: '#DBDBE2',
                middle: '#B3B3BD',
                dark: '#808091',
                transparent: '#F2F2F280'
            },
            'dark-gray': {
                DEFAULT: '#808091'
            },
            'movie-pilot': {
                orange: '#F4645A'
            },
            red: {
                DEFAULT: '#FF3933'
            },
            orange: {
                DEFAULT: '#FFA620',
                dark: '#E06019',
                light: '#FFDD5C',
                gradient: '#ED820E'
            },
            yellow: {
                DEFAULT: '#FFDE2E'
            },
            violetGrey: {
                DEFAULT: '#887D9A'
            },
            // The sticky table header's backdrop. Defaults to the page's own dark surface and is
            // overridable per app via the CSS variable, because tenant themes change the page behind it.
            'table-surface': 'var(--table-surface, #000023)',
            // The shared table's own chrome (dividers, stripes, muted labels, paginator). Falls back to
            // `white` (#F2F2F2), which is what that chrome always painted on the dark page; a table with
            // `surface="panel"` points the variable at the panel's `--on-non-transparent-surface-color-rgb`.
            'table-fg': 'rgba(var(--table-fg-rgb, 242, 242, 242), <alpha-value>)',
            // The Room Studio's light/dark theme (room-studio/src/theme/studio-theme.ts): the
            // studio root sets the `--studio-*-rgb` variables, the fallbacks are the dark theme.
            studio: {
                bg: 'rgba(var(--studio-bg-rgb, 0, 0, 35), <alpha-value>)',
                surface: 'rgba(var(--studio-surface-rgb, 12, 12, 45), <alpha-value>)',
                'surface-2': 'rgba(var(--studio-surface-2-rgb, 24, 24, 57), <alpha-value>)',
                'surface-hover': 'rgba(var(--studio-surface-hover-rgb, 38, 38, 74), <alpha-value>)',
                fg: 'rgba(var(--studio-fg-rgb, 242, 242, 242), <alpha-value>)',
                'fg-muted': 'rgba(var(--studio-fg-muted-rgb, 180, 180, 192), <alpha-value>)',
                'fg-subtle': 'rgba(var(--studio-fg-subtle-rgb, 148, 148, 166), <alpha-value>)',
                border: 'rgba(var(--studio-border-rgb, 34, 34, 74), <alpha-value>)',
                'border-strong': 'rgba(var(--studio-border-strong-rgb, 88, 88, 128), <alpha-value>)',
                accent: 'rgba(var(--studio-accent-rgb, 0, 255, 220), <alpha-value>)',
                'accent-line': 'rgba(var(--studio-accent-line-rgb, 0, 255, 220), <alpha-value>)',
                'accent-fg': 'rgba(var(--studio-accent-fg-rgb, 0, 0, 35), <alpha-value>)',
                danger: 'rgba(var(--studio-danger-rgb, 255, 90, 84), <alpha-value>)',
                warning: 'rgba(var(--studio-warning-rgb, 255, 166, 32), <alpha-value>)',
                success: 'rgba(var(--studio-success-rgb, 64, 229, 135), <alpha-value>)'
            }
        },

        scale: {
            '-100': '-1',
            0: '0',
            '01': '0.001',
            1: '0.01',
            25: '.25',
            50: '.5',
            75: '.75',
            90: '.9',
            95: '.95',
            100: '1',
            101: '1.01',
            105: '1.05',
            110: '1.1',
            125: '1.25',
            150: '1.5',
            200: '2'
        }
    }
};

export default CineamoTheme satisfies Partial<Config>;
